import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

export const signInWithGoogle = async () => {
  const auth = getAuth();
  const provider = new GoogleAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    // You can handle the result here, e.g.,
    // const user = result.user;
    return { user: result.user };
  } catch (error) {
    // Handle Errors here.
    return { error };
  }
};
